const API_URL = process.env.REACT_APP_API_BASE_URL || '';

export class SalesService {
  static async getSales(authorizedFetch, params = {}) {
    const tzOffset = new Date().getTimezoneOffset();
    const finalParams = { tzOffset, ...params };
    const qs = new URLSearchParams(
      Object.fromEntries(Object.entries(finalParams).filter(([, v]) => v != null))
    ).toString();
    const response = await authorizedFetch(`${API_URL}/api/sales${qs ? `?${qs}` : ''}`);
    if (!response.ok) throw new Error(await response.text());
    return response.json();
  }

  static async getSummary(authorizedFetch) {
    const tzOffset = new Date().getTimezoneOffset();
    const response = await authorizedFetch(`${API_URL}/api/sales/summary?date=today&tzOffset=${tzOffset}`);
    if (!response.ok) throw new Error(await response.text());
    return response.json();
  }

  static async getSale(id, authorizedFetch) {
    const response = await authorizedFetch(`${API_URL}/api/sales/${id}`);
    if (!response.ok) throw new Error(await response.text());
    return response.json();
  }

  static async createSale(data, authorizedFetch) {
    const response = await authorizedFetch(`${API_URL}/api/sales`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error(await response.text());
    return response.json();
  }

  static async updateSale(id, data, authorizedFetch) {
    const response = await authorizedFetch(`${API_URL}/api/sales/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error(await response.text());
    return response.json();
  }

  static async addPayment(saleId, payment, authorizedFetch) {
    const response = await authorizedFetch(`${API_URL}/api/sales/${saleId}/payments`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payment),
    });
    if (!response.ok) throw new Error(await response.text());
    return response.json();
  }

  static async cancelSale(id, authorizedFetch) {
    const response = await authorizedFetch(`${API_URL}/api/sales/${id}/cancel`, {
      method: 'PATCH',
    });
    if (!response.ok) throw new Error(await response.text());
    return response.json();
  }

  static async deletePayment(saleId, paymentId, authorizedFetch) {
    const response = await authorizedFetch(
      `${API_URL}/api/sales/${saleId}/payments/${paymentId}`,
      { method: 'DELETE' }
    );
    if (!response.ok) throw new Error(await response.text());
    return response.json();
  }
}
